export const isFullUrl: (url: string) => boolean = (url: string): boolean => {
  try {
    return !!new URL(url);
  } catch {
    return false;
  }
};
